const GET_FLEET_DISPOSITION_SAVE = "GET_FLEET_DISPOSITION_SAVE"
const SET_FLEET_DISPOSITION_SAVE = "SET_FLEET_DISPOSITION_SAVE"

export{
    GET_FLEET_DISPOSITION_SAVE,
    SET_FLEET_DISPOSITION_SAVE
}